'use client';

import { PropsWithChildren } from 'react';

import { IS_TRACKING_ENABLED } from '@/common/constants';
import { SafePostHogProvider } from '@/hooks/use-safe-posthog';
import { posthogStandIn } from '@/lib/analytics/posthog-stand-in';

/**
 * Bridges analytics into React context via SafePostHogProvider. The value is the stand-in, not
 * posthog-js itself: posthog loads after the chat is ready, and the stand-in keeps what the chat
 * records until then. It is one object for the life of the page, so consumers' effects run once.
 *
 * Always renders the provider, even with `null` (tracking off): a consumer mounted without it
 * reads `null` for good, and `WidgetAnalyticsProvider`'s super properties would never be set.
 */
export function PostHogProvider({ children }: PropsWithChildren) {
  return (
    <SafePostHogProvider value={IS_TRACKING_ENABLED ? posthogStandIn : null}>
      {children}
    </SafePostHogProvider>
  );
}
